import React from "react";
import LegalLayout from "../LegalLayout";

export default function RGPD() {
  return (
    <LegalLayout testid="rgpd-page" eyebrow="Conformité" title="Informations RGPD" lastUpdate="14 octobre 2026">
      <h2>Acta Documentum — Projet Ego Automata</h2>
      <p>
        Acta Documentum est une application développée dans le cadre du projet entrepreneurial
        <strong> Ego Automata</strong>, actuellement en cours de création, et mise à disposition
        de <strong>LIRAH SAS</strong> pour des tests privés réalisés par ses salariés et prestataires.
        Alma France est une société envisagée, non encore constituée.
      </p>
      <p>
        Ces tests utilisent des données personnelles réelles : comptes des utilisateurs,
        contacts professionnels, clients, prospects et informations contenues dans les
        documents ou messages. La phase de test ne dispense pas des obligations du RGPD.
        Les finalités, bases légales et durées de conservation doivent être documentées.
      </p>
      <h2>Traitements liés aux documents partagés</h2>
      <p>
        L'application permet de suivre les ouvertures et les durées de consultation
        des documents partagés. Ces événements peuvent être associés à un destinataire
        ou à un prospect. Les événements de partage concernés n'enregistrent plus
        l'adresse IP du visiteur.
      </p>
      <h2>Vos droits</h2>
      <p>
        Selon les conditions prévues par le RGPD, vous pouvez demander l'accès,
        la rectification, l'effacement ou la limitation de vos données, et exercer
        votre droit d'opposition. Vous pouvez également saisir la CNIL.
      </p>
      <p>
        Pour une demande relative à vos données :
        {" "}<a href="mailto:contact@acta-documentum.fr">contact@acta-documentum.fr</a>.
      </p>
      <p>
        LIRAH SAS est l'entreprise utilisatrice actuelle. La qualification de responsable
        du traitement pour chaque opération doit être confirmée selon la détermination
        effective des finalités et moyens essentiels. Les bases légales, destinataires,
        durées de conservation et éventuels transferts doivent être précisés.
        Cette page reste provisoire tant que ces informations ne sont pas vérifiées.
      </p>
    </LegalLayout>
  );
}
